<template>
    <!-- Meta Tags -->
    <Head title="Recetas" />

    <section class="bg-recipes bg-effect-right min-h-screenheaderfooter">
        <div class="container pt-8 pb-16">
            <nav class="flex" aria-label="Breadcrumb">
                <div class="container rounded py-1">
                    <ol class="inline-flex items-center space-x-1 md:space-x-2">
                        <li class="inline-flex items-center">
                            <Link
                                href="/"
                                class="inline-flex items-center text-sm font-medium text-white hover:text-orange hover:underline"
                            >
                                <svg
                                    aria-hidden="true"
                                    class="w-4 h-4 mr-2"
                                    fill="currentColor"
                                    viewBox="0 0 20 20"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M10.707 2.293a1 1 0 00-1.414 0l-7 7a1 1 0 001.414 1.414L4 10.414V17a1 1 0 001 1h2a1 1 0 001-1v-2a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 001 1h2a1 1 0 001-1v-6.586l.293.293a1 1 0 001.414-1.414l-7-7z"
                                    ></path>
                                </svg>
                                Inicio
                            </Link>
                        </li>
                        <li aria-current="page">
                            <div class="flex items-center">
                                <svg
                                    aria-hidden="true"
                                    class="w-6 h-6 text-white"
                                    fill="currentColor"
                                    viewBox="0 0 20 20"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        fill-rule="evenodd"
                                        d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                                        clip-rule="evenodd"
                                    ></path>
                                </svg>
                                <span class="ml-1 text-sm font-bold md:ml-2">Recetas</span>
                            </div>
                        </li>
                    </ol>
                </div>
            </nav>

            <h1 class="hidden">Recetas</h1>
            <h2 class="text-center pb-8 pt-6 md:pb-14">¡MANOS A LA CHISPA!</h2>

            <div class="flex flex-col sm:flex-row gap-4 justify-between items-center mb-8" id="main-content">
                <div class="w-full sm:w-auto flex flex-col justify-start items-start">
                    <form @submit.prevent="searchRecipe" class="w-full">
                        <label for="searchRecipes" class="w-full font-helvetica text-lg ml-2 mb-1 block"
                            >Buscar recetas:</label
                        >
                        <div
                            class="relative w-full sm:w-80 h-10 bg-lightgray text-black rounded-md flex justify-between items-center"
                        >
                            <div class="w-12 absolute left-0 h-full flex justify-center items-center">
                                <font-awesome-icon icon="fa-regular fa-magnifying-glass" />
                            </div>
                            <input
                                id="searchRecipes"
                                class="bg-white w-full h-full pl-10 rounded-l-md font-helvetica placeholder:text-xs placeholder:sm:text-sm"
                                v-model="search"
                                type="text"
                                placeholder="Encuentra tu receta favorita"
                            />
                            <button
                                type="submit"
                                class="w-32 h-full bg-blue text-white rounded-r-md transition-all ease-linear hover:bg-blue"
                            >
                                Buscar
                            </button>
                        </div>
                    </form>
                </div>

                <div class="w-full sm:w-auto flex flex-col justify-start items-start">
                    <label for="categoria" class="text-lg font-helvetica">Categoría:</label>
                    <select
                        id="categoria"
                        @change="categorySelected($event)"
                        v-model="category"
                        class="bg-white text-blue w-full sm:w-60 h-10 rounded-md px-2 font-helvetica"
                    >
                        <option value="">Todas las recetas</option>
                        <option>Para compartir</option>
                        <option>Indulgentes</option>
                        <option>Postres rápidos</option>
                    </select>
                </div>
            </div>

            <div
                v-if="recipes.data.length"
                class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 lg:gap-8"
            >
                <article
                    v-for="(recipe, index) in recipes.data"
                    :key="index"
                    class="group w-full rounded-2xl overflow-hidden"
                >
                    <div class="w-full flex justify-center items-center">
                        <img
                            class="w-full h-auto"
                            :src="
                                recipe.thumbnail
                                    ? `/storage/recipes/${recipe.thumbnail}`
                                    : `https://img.youtube.com/vi/${recipe.video_url}/mqdefault.jpg`
                            "
                            :alt="recipe.name"
                        />
                    </div>
                    <div class="bg-blue w-full h-32 space-y-2 p-4 flex flex-col justify-between items-start">
                        <p class="text-sm md:text-base">
                            {{ recipe.name }}
                        </p>
                        <div class="w-full flex justify-between items-center space-x-1">
                            <span class="text-[14px]">
                                <font-awesome-icon icon="fa-regular fa-bowl-hot" class="text-lg mr-2" />
                                {{ recipe.difficulty }}
                            </span>
                            <!-- <span class="text-[14px]">10 min</span> -->
                            <span class="text-[14px]">
                                <font-awesome-icon icon="fa-solid fa-user" class="text-lg mr-2" />
                                {{ recipe.portions }}
                            </span>
                            <Link :href="`/recetas/${recipe.slug}`" class="text-sm btn-white shrink-0">
                                Ver Receta
                            </Link>
                        </div>
                    </div>
                </article>
            </div>

            <div class="min-h-screen-1/3 flex flex-col justify-start items-start" v-else>
                <div>Lo sentimos, no encontramos tu búsqueda:</div>
                <h2 class="text-5xl">"{{ search }}"</h2>
                <div class="mt-16 mb-4">Te recomendamos otras recetas como:</div>
                <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 lg:gap-8 mx-auto">
                    <article
                        v-for="(recipe, index) in random_recipes"
                        :key="index"
                        class="group w-full rounded-2xl overflow-hidden"
                    >
                        <div class="w-full h-52 flex justify-center items-center">
                            <img
                                class="w-full h-full object-cover bg-center"
                                :src="
                                    recipe.thumbnail
                                        ? `/storage/recipes/${recipe.thumbnail}`
                                        : `https://img.youtube.com/vi/${recipe.video_url}/mqdefault.jpg`
                                "
                                :alt="recipe.name"
                            />
                        </div>
                        <div class="bg-blue w-full h-32 space-y-2 p-4 flex flex-col justify-between items-start">
                            <p class="text-sm md:text-base">
                                {{ recipe.name }}
                            </p>
                            <div class="w-full flex justify-between items-center space-x-1">
                                <span class="text-[14px]">
                                    <font-awesome-icon icon="fa-regular fa-bowl-hot" class="text-lg mr-2" />
                                    {{ recipe.difficulty }}
                                </span>
                                <!-- <span class="text-[14px]">10 min</span> -->
                                <span class="text-[14px]">
                                    <font-awesome-icon icon="fa-solid fa-user" class="text-lg mr-2" />
                                    {{ recipe.portions }}
                                </span>
                                <Link
                                    :href="`/recetas/${recipe.slug}`"
                                    class="text-sm btn-white shrink-0"
                                    :aria-label="`Ver más sobre ${recipe.name}`"
                                >
                                    Ver Receta
                                </Link>
                            </div>
                        </div>
                    </article>
                </div>
            </div>

            <div class="flex justify-center items-center mt-8 font-helvetica">
                <Component
                    v-if="recipes.data.length"
                    :is="link.url ? 'Link' : 'span'"
                    v-for="(link, index) in recipes.links"
                    :key="index"
                    :href="link.url"
                    v-html="link.label"
                    class="text-xl mx-2"
                    :class="{
                        'text-transparent': !link.url,
                        'text-white': link.url,
                        'font-bold underline': link.active,
                    }"
                >
                </Component>
            </div>
        </div>
    </section>

    <Transition>
        <section
            v-show="showChocolover"
            class="fixed top-0 left-0 w-full h-full bg-black bg-opacity-80 flex justify-center items-center p-4 z-10"
        >
            <div class="relative container max-w-5xl bg-lightblue rounded-xl py-8 px-4 md:px-8">
                <div @click="showChocolover = false" class="absolute top-3 right-4 text-white cursor-pointer">
                    <font-awesome-icon icon="fa-regular fa-xmark" class="text-4xl" />
                </div>

                <h2
                    class="text-lg text-center pt-2 md:pt-0 md:text-2xl flex flex-col justify-center items-center md:flex-row"
                >
                    ¡SELECCIONA UN PLAN Y TE AYUDAMOS CON
                    <img
                        class="w-24 md:w-32 md:ml-4"
                        :src="`/images/logo_chokitip.png`"
                        alt="Choki Tip"
                    />
                </h2>

                <div class="my-4">
                    <swiper
                        :a11y="{
                            prevSlideMessage: 'Anterior',
                            nextSlideMessage: 'Siguiente',
                        }"
                        :centeredSlides="false"
                        :spaceBetween="30"
                        :slidesPerView="1"
                        :grabCursor="true"
                        :loop="false"
                        :navigation="true"
                        :modules="modules"
                        :breakpoints="{
                            320: {
                                slidesPerView: 1,
                            },
                            60: {
                                slidesPerView: 2,
                            },
                            900: {
                                slidesPerView: 3,
                            },
                        }"
                        v-if="chocolover_recipes.length"
                        class="swiperRetailers !px-6"
                    >
                        <swiper-slide v-for="(recipe, index) in chocolover_recipes" :key="index" class="w-1/2">
                            <div
                                class="bg-blueCircles w-full bg-cover bg-no-repeat bg-center rounded-lg overflow-hidden"
                            >
                                <div class="w-full flex justify-center items-center">
                                    <img
                                        class="w-full h-auto"
                                        :src="
                                            recipe.thumbnail
                                                ? `/storage/recipes/${recipe.thumbnail}`
                                                : `https://img.youtube.com/vi/${recipe.video_url}/mqdefault.jpg`
                                        "
                                        :alt="recipe.name"
                                    />
                                </div>
                                <div class="bg-pink w-full h-24 flex justify-between items-center p-2 sm:p-4">
                                    <p class="text-sm pr-2 md:text-base">{{ recipe.name }}</p>
                                    <Link
                                        :href="`/recetas/${recipe.slug}`"
                                        class="text-sm md:text-base btn-white shrink-0"
                                        >Ver Receta
                                    </Link>
                                </div>
                            </div>
                        </swiper-slide>
                    </swiper>
                    <div v-else class="w-full h-48 flex justify-center items-center font-bold">
                        NO SE ENCONTRARON RESULTADOS
                    </div>
                </div>

                <h2 class="text-center mb-8">¿QUÉ TAN CHOCOLOVER ERES?</h2>
                <div class="bg-blue w-full max-w-xl mx-auto rounded-full h-16 px-2 flex justify-center items-center">
                    <div class="w-14 h-14 rounded-full bg-red shrink-0 flex justify-center items-center">
                        <font-awesome-icon icon="fa-light fa-thumbs-up" class="text-white text-3xl" />
                    </div>
                    <input
                        type="range"
                        name=""
                        class="slider_chocolover w-full"
                        min="1"
                        max="4"
                        @change="changeRangeChocolover"
                        v-model="level"
                    />
                    <div class="w-14 h-14 rounded-full bg-[#f8fd32] shrink-0 flex justify-center items-center">
                        <font-awesome-icon icon="fa-solid fa-heart" class="text-blue text-2xl" />
                    </div>
                </div>
            </div>
        </section>
    </Transition>
</template>

<script>
import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

import { Navigation, Pagination, A11y } from "swiper";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

export default {
    components: {
        Swiper,
        SwiperSlide,
    },
    props: {
        recipes: Object,
        filters: Object,
        chocolover_recipes: Object,
        chocolover_filters: Object,
        random_recipes: Object,
    },
    data() {
        return {
            modules: [Navigation, Pagination, A11y],
            search: this.filters.search || "",
            category: this.filters.category || "",
            showChocolover: this.chocolover_filters.showChocolover || false,
            level: this.chocolover_filters.level || 1,
        };
    },
    mounted() {
        const timeline = gsap.timeline({});
        const recipes = document.querySelectorAll(".group");

        recipes.forEach((item) => {
            timeline.fromTo(
                item,
                {
                    opacity: 0,
                    translateY: 100,
                },
                {
                    opacity: 1,
                    translateY: 0,
                    duration: 0.2,
                }
            );
        });

        if (this.recipes.current_page == 2 && this.showChocolover == false) {
            this.showChocolover = true;
        }
    },
    methods: {
        searchRecipe(value) {
            this.$inertia.get(
                "/recetas",
                { search: this.search, category: this.category },
                {
                    preserveState: true,
                    replace: true,
                }
            );
        },
        categorySelected(event) {
            this.search = "";
            this.searchRecipe(event.target.value);
        },
        changeRangeChocolover() {
            this.$inertia.get(
                "/recetas",
                { level: this.level, showChocolover: this.showChocolover },
                {
                    preserveState: true,
                    replace: true,
                }
            );
        },
    },
};
</script>
<style>
.swiper-pagination-bullet {
    width: 10px;
    height: 10px;
}

.swiper-pagination-bullet-active {
    background: theme("colors.white");
}

.swiper-button-prev {
    left: 0px;
    right: auto;
    background-color: #fff;
    border-radius: 50%;
    width: 3rem;
    height: 3rem;
    display: flex;
    justify-content: center;
    align-items: center;
}

.swiper-button-prev:after {
    font-size: 1.5rem;
    color: theme("colors.blue");
}

.swiper-button-next {
    right: 0px;
    left: auto;
    background-color: #fff;
    border-radius: 50%;
    width: 3rem;
    height: 3rem;
    display: flex;
    justify-content: center;
    align-items: center;
}

.swiper-button-next:after {
    font-size: 1.5rem;
    color: theme("colors.blue");
}

/* swiperSlider */
.swiperSlider .swiper-button-prev {
    left: 2rem;
}

.swiperSlider .swiper-button-next {
    right: 2rem;
}

@media (max-width: 640px) {
    .swiper-button-prev,
    .swiper-button-next {
        width: 2.4rem;
        height: 2.4rem;
    }

    .swiperSlider .swiper-button-prev {
        left: 0.5rem;
    }

    .swiperSlider .swiper-button-next {
        right: 0.5rem;
    }
}

.swiper-button-lock {
    display: none !important;
}
</style>
